import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoadingSpinner from './LoadingSpinner';

// Иерархия: какие роли имеют доступ к requiredRole
const ROLE_ACCESS = {
  admin: ['admin', 'top_boss'],
  manager: ['admin', 'top_boss', 'manager', 'moderator'],
  curator: ['admin', 'top_boss', 'manager', 'curator'],
  moderator: ['admin', 'top_boss', 'manager', 'moderator'],
  user: ['admin', 'top_boss', 'manager', 'curator', 'moderator', 'user'],
};

const PrivateRoute = ({ children, requiredRole }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <LoadingSpinner />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (requiredRole) {
    const allowedRoles = ROLE_ACCESS[requiredRole] || [];
    if (!allowedRoles.includes(user.role)) {
      return <Navigate to="/" replace />;
    }
  }

  return children;
};

export default PrivateRoute;
